export const ADMIN_USER_TYPES = [
  'Vice Chancellor',
  'System Admin',
  'Admin',
]

export const READ_ONLY_USER_TYPES = [
  'DVC ASAR',
  'DVC PAF',
  'Director Drie',
]

export const LIMITED_USER_TYPES = [
  'Project Member',
  'Project Member Research',
  'Project Member ICT',
  'Principal Investigator',
  'Co-Principal Investigator',
  'Project Manager',
  'Grant Accountant',
  'Accountant',
]

const normalizeType = (value) => String(value || '').trim()

export function getAccessLevel(userType) {
  const normalized = normalizeType(userType)
  if (ADMIN_USER_TYPES.includes(normalized)) return 'admin'
  if (READ_ONLY_USER_TYPES.includes(normalized)) return 'read_only'
  if (LIMITED_USER_TYPES.includes(normalized)) return 'limited'
  return 'limited'
}

export function canEdit(userType) {
  return getAccessLevel(userType) === 'admin'
}

export function canViewAll(userType) {
  return getAccessLevel(userType) !== 'limited'
}

export function isLimited(userType) {
  return getAccessLevel(userType) === 'limited'
}

export function isReadOnly(userType) {
  return getAccessLevel(userType) === 'read_only'
}

export function isAdmin(userType) {
  return getAccessLevel(userType) === 'admin'
}

export function getUserId(user) {
  return user?.userId || user?.uid || user?.id || ''
}

export function isPathAllowedForLevel(accessLevel, pathname) {
  if (!pathname) return true
  if (accessLevel === 'read_only') {
    const blocked = [
      /^\/dashboard\/projects\/new\/?$/,
      /^\/dashboard\/proposals\/new\/?$/,
    ]
    if (blocked.some((pattern) => pattern.test(pathname))) return false
    return true
  }
  if (accessLevel !== 'limited') return true

  const allowed = [
    /^\/dashboard\/?$/,
    /^\/dashboard\/profile\/?$/,
    /^\/dashboard\/proposals(\/.*)?$/,
    /^\/dashboard\/awards(\/.*)?$/,
    /^\/dashboard\/projects(\/.*)?$/,
    /^\/dashboard\/workplans\/?$/,
  ]

  return allowed.some((pattern) => pattern.test(pathname))
}

export function isUserAssociatedWithProject(project, userId) {
  if (!project || !userId) return false
  const directIds = [
    project.principalInvestigatorId,
    project.projectManagerId,
    project.leadPersonId,
    project.ownerId,
    project.createdBy,
    project.createdById,
  ]
  if (directIds.filter(Boolean).some((id) => id === userId)) return true

  const memberIds = []
  const members = Array.isArray(project.projectMembers) ? project.projectMembers : []
  members.forEach((member) => {
    if (member?.userId) memberIds.push(member.userId)
    if (member?.id) memberIds.push(member.id)
    if (typeof member === 'string') memberIds.push(member)
  })

  const coInvestigators = []
  const coIds = [
    ...(Array.isArray(project.coInvestigatorIds) ? project.coInvestigatorIds : []),
    ...(Array.isArray(project.coPrincipalInvestigatorIds) ? project.coPrincipalInvestigatorIds : []),
  ]
  coIds.forEach((id) => {
    if (id) coInvestigators.push(id)
  })
  if (project.coPrincipalInvestigatorId) coInvestigators.push(project.coPrincipalInvestigatorId)

  return [...memberIds, ...coInvestigators].includes(userId)
}

export function isUserAssociatedWithProposal(proposal, userId) {
  if (!proposal || !userId) return false
  if (proposal.submittedBy && proposal.submittedBy === userId) return true
  const members = Array.isArray(proposal.members) ? proposal.members : []
  return members.some((member) => member?.userId === userId || member?.id === userId)
}

export function isUserAssociatedWithAward(award, userId) {
  if (!award || !userId) return false
  const directIds = [
    award.principalInvestigator?.userId,
    award.coPrincipalInvestigator?.userId,
  ].filter(Boolean)
  if (directIds.includes(userId)) return true
  const projectMembers = Array.isArray(award.projectMembers) ? award.projectMembers : []
  return projectMembers.some((member) => member?.userId === userId || member?.id === userId)
}
